import * as React from "react";
import { Avatar, makeStyles } from "@material-ui/core";
import classNames from "classnames";

import { LogoClock } from "@components/logo";
import { greys, colors } from "@styles/color.styles";

export interface AvatarGenericProps {
  imgUrl?: string;
  name?: string;
  showBadge?: boolean;
}

const useStyles = makeStyles({
  avatar: {
    position: "relative",
    maxWidth: 34,
    width: "100%",
    "& > div:first-child": {
      height: 34,
      width: 34,
    },
  },
  badge: {
    position: "absolute",
    backgroundColor: colors.blueCool.standard,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
    height: 18,
    width: 18,
    right: -3,
    bottom: -3,
  },
  background__initials: {
    backgroundColor: colors.blueCool.standard,
    color: greys.white,
  },
});

export const AvatarGeneric = ({ imgUrl, name, showBadge }: AvatarGenericProps) => {
  const classes = useStyles();

  return (
    <div className={classes.avatar}>
      <Avatar
        className={classNames([{ [classes.background__initials]: !imgUrl }])}
        src={imgUrl}
        alt={name}
      >
        {(name && name[0].toUpperCase()) || "C"}
      </Avatar>
      {showBadge && (
        <div className={classes.badge}>
          <LogoClock size={14} fill={greys.white} />
        </div>
      )}
    </div>
  );
};
